import { useAppContext } from 'src/components/app-context';
import { useSelector } from 'react-redux';
import type { AppState } from 'reducers';
import { useMetaTags } from 'src/hooks/use-meta-tags';
import { useMatchedRoute } from 'src/hooks/use-matched-route';

export function usePageMetaTags(data: unknown) {
  const context = useAppContext();
  const matchedRoute = useMatchedRoute();
  const hrefLang = useSelector((state: AppState) => state.globals.hrefLang);

  let metaTags = {};

  if (matchedRoute && matchedRoute.metaTags) {
    metaTags = matchedRoute.metaTags(
      {
        data,
        hrefLang,
        routeName: matchedRoute.name,
        ...matchedRoute.variables,
      },
      context
    );
  }

  useMetaTags({ metaTags });
}
